import {useLocation, useNavigate} from "react-router-dom";
import {useState} from "react";
import AdminHeader from "../../Components/AdminHeader/AdminHeader";
import AdminNav from "../../Components/AdminNav/AdminNav";
import { IMAGE_URL} from "../../path";
import {updateProduct} from "../../actions/Products";

function EditBrandHero () {
    const location = useLocation();
    const user = location.state?.user;
    const brand = location.state?.brand;
    const navigate = useNavigate();

    if (location === null || location.state === null || location.state.user === null) {
        navigate('/login');
    }

    const [isCollapsed, setIsCollapsed] = useState(true);
    const publicPath = IMAGE_URL;

    async function handleSubmit(e: React.FormEvent) {
        e.preventDefault();

        try {
            if (imageFileDesktop) {
                await updateProduct({id: brand.id, brand_hero: imageFileDesktop})
                alert("Home page image updated successfully!");
                navigate('/dashboard/wines/brands', { state: { user: user } })
            }
        } catch(e)
        {
            alert("Failed to update home page image. Please try again.");
        }

    }

    const [imageError, setImageError] = useState<string>("");
    const [imageFileDesktop, setImageFileDesktop] = useState<File | null>(null);
    const [previewUrlDesktop, setPreviewUrlDesktop] = useState<string>(`${IMAGE_URL}${brand.image_path}`);

    const handleImageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (file) {
            if (!["image/jpeg", "image/jpg", "image/png"].includes(file.type)) {
                setImageError("Please upload a valid image file (jpg, jpeg, or png).");
                setImageFileDesktop(null);

            }

            setImageError("");
            const objectUrl = URL.createObjectURL(file);

                setImageFileDesktop(file);
                setPreviewUrlDesktop(objectUrl);

        }
    };

    const removeSelectedImage = () => {
        setImageFileDesktop(null);
        setPreviewUrlDesktop(`${IMAGE_URL}${brand.gallery_hero[0].hero_image}`);
    };

    return <div>
        <AdminHeader isCollapsed={isCollapsed} setIsCollapsed={setIsCollapsed} user={user} />
        <AdminNav collapsed={isCollapsed} setCollapsed={setIsCollapsed} user={user} />

        <div className={`main-admin-page ${isCollapsed ? 'collapsed' : 'expanded'}`}>
            <div className="main-admin-page-inner">
                <form onSubmit={handleSubmit}>
                    <div className="content-form-field">
                        <h2>Edit Brand Hero Image</h2>
                        <input
                            type="text"
                            className="input-email"
                            placeholder="Brand Name"
                            value={brand.name}
                            disabled

                        />
                    </div>

                    {/* Desktop Image Upload */}
                    <div className="content-form-field">
                        <label><strong>Desktop Image</strong></label><br />
                        <input
                            type="file"
                            accept=".jpg,.jpeg,.png"
                            onChange={(e) => handleImageChange(e, )}
                            style={{ margin: '10px 0' }}
                        />
                        {imageError && <div style={{ color: 'red' }}>{imageError}</div>}
                        {previewUrlDesktop && (
                            <div style={{ marginTop: '10px' }}>
                                <img
                                    src={previewUrlDesktop}
                                    alt="Desktop Preview"
                                    style={{ maxWidth: '100%', maxHeight: '300px', border: '1px solid #ccc' }}
                                />
                                <br />
                                <button type="button" onClick={() => removeSelectedImage()} style={{ marginTop: '5px' }}>
                                    Remove Gallery Image
                                </button>
                            </div>
                        )}
                    </div>

                    <button type="submit" className="btn-submit">Save Changes</button>
                </form>
            </div>
        </div>
    </div>


}

export default EditBrandHero;
